customElements.define(
  'quiz-result',
  class QuizResult extends HTMLElement {
    constructor() {
      super();
      this.resultContainer = this.querySelector('[data-quiz-product]');
      this.articlesContainer = this.querySelector('[data-quiz-list-articles]');
      this.reviewsContainer = this.querySelector('[data-quiz-reviews]');
      this.upsellElements = this.querySelectorAll('[data-quiz-upsell]');
      this.encarts = this.querySelectorAll('[data-quiz-encart]');
    }

    async connectedCallback() {
      await this.init();
    }

    async init() {
      if (window.location.href.indexOf('product_1=') > -1) {
        let params = new URL(location.href).searchParams;
        console.log(params, "params");
    
        let product_handles = [];
        for (let index = 0; index < 4; index++) {
          product_handles.push(params.get('product_' + (index + 1)));
        }
    
        console.log(product_handles, "product_handles");
    
        for (let index = 0; index < 4; index++) {
          if (product_handles[index] != null) {
            await this.getProductTemplate(product_handles[index]);
            await this.getReviewsTemplate(product_handles[index]);
          }
        }
    
        let article_handles = [];
        for (let index = 0; index < 3; index++) {
          article_handles.push(params.get('article_' + (index + 1)));
        }
    
        console.log(article_handles, "article_handles");
    
        for (let index = 0; index < 3; index++) {
          if (article_handles[index] != null) {
            await this.getArticleTemplate(article_handles[index], index);
          }
        }
    
        let name_animal = params.get('name_animal');
        if (name_animal) {
          this.replaceAllNames(document.body, name_animal);	
        } else {
          this.replaceAllNames(document.body, 'votre animal');
        }
    
        let type_animal = params.get('type_animal');
        if (type_animal) {
          this.setUpsell(type_animal);
        }
    
        let problematiques = [];
        for (let index = 0; index < 3; index++) {
          problematiques.push(params.get('problematique_' + (index + 1)));
        }
    
        if (problematiques.length > 0 && type_animal) {
          this.setProblematiques(problematiques, type_animal);
        }

        document.querySelectorAll('.bundle-product .trustpilot-widget').forEach((elem) => {
          window.Trustpilot.loadFromElement(elem); 
        });
            
        this.showResults();
        this.showReviews();
      } else {
        let quizResults = localStorage.getItem('quizResultsV2');
        
        // Check if quiz results exist
        if (!quizResults) {
          console.log('No quiz results found in localStorage');
          return;
        }
        
        let quizResultsJSON = JSON.parse(quizResults);
        
        // Check if parsed data is valid
        if (!quizResultsJSON) {
          console.log('Invalid quiz results data');
          return;
        }
        
        let handle_product_selected = [];
        let handle_article_selected = [];
    
        for (let i = 1; i <= 5; i++) {
          if (quizResultsJSON['product_' + i] != null) {
            await this.getProductTemplate(quizResultsJSON['product_' + i]);
            await this.getReviewsTemplate(quizResultsJSON['product_' + i]);
            handle_product_selected.push(quizResultsJSON['product_' + i]);
          }
        }
    
        for (let i = 1; i <= 3; i++) {
          if (quizResultsJSON['article_' + i] != null) {
            await this.getArticleTemplate(quizResultsJSON['article_' + i]);
            handle_article_selected.push(quizResultsJSON['article_' + i]);
          }
        }
    
        let result_url = window.location.href;
        handle_product_selected.forEach((handle, index) => {
          result_url += (index == 0 ? '?' : '&') + "product_" + (index + 1) + "=" + handle;
        });
        handle_article_selected.forEach((handle, index) => {
          result_url += '&' + "article_" + (index + 1) + "=" + handle;
        });
    
        if (quizResultsJSON.name_pet != null) {
          result_url += '&' + "name_animal=" + quizResultsJSON.name_pet;
          this.replaceAllNames(document.body, quizResultsJSON.name_pet);
        } else {
          this.replaceAllNames(document.body, 'votre animal');
        }
        
        if (quizResultsJSON.type_animal != null) {
          result_url += '&' + "type_animal=" + quizResultsJSON.type_animal;
          this.setUpsell(quizResultsJSON.type_animal);
        }
        if (quizResultsJSON.age_animal != null) {
          result_url += '&' + "age_animal=" + quizResultsJSON.age_animal;
        }
        if (quizResultsJSON.problematique != null && quizResultsJSON.type_animal != null) {
          for (let index = 0; index < quizResultsJSON.problematique.length; index++) {
            result_url += '&' + "problematique_" + (index + 1) + "=" + quizResultsJSON.problematique[index];
          }
          this.setProblematiques(quizResultsJSON.problematique, quizResultsJSON.type_animal);
        }

        document.querySelectorAll('.bundle-product .trustpilot-widget').forEach((elem) => {
          window.Trustpilot.loadFromElement(elem); 
        });
    
        console.log(result_url);
        let share_url = result_url;
        let state = { user: 1 };
        let title = 'Franklin - Questionnaire';
        history.pushState(state, title, encodeURI(share_url));
    
        this.showResults();
        this.showReviews();

        // tracking quiz result
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "quiz_completed",
          customer_data: {
            email: quizResultsJSON.email
          },
          quiz_newsletter: quizResultsJSON.accept_marketing
        });

        let s2sevent = new CustomEvent("hb_s2s_event", { 
          detail: { 
            type: 'quiz_completed', 
            email: quizResultsJSON.email,
            quiz_newsletter: quizResultsJSON.accept_marketing
          } 
        });
        window.dispatchEvent(s2sevent);
    
        setTimeout(() => {
          // Klaviyo unset_values
          let unset_values = {
            '$email': quizResultsJSON.email,
            "Quizz : Type Animal": null,
            "Quizz : Age an": null,
            "Quizz : Age mois": null,
            "Quizz : Taille": null,
            "Quizz : Problématique 1": null,
            "Quizz : Problématique 2": null,
            "Quizz : Problématique 3": null,
            "Quizz : Résultat 1": null,
            "Quizz : Résultat 2": null,
            "Quizz : Résultat 3": null,
            "Quizz : Résultat 4": null,
            "Quizz : Résultat 5": null,
            "Quizz : Sexe": null,
            "Quizz : Poids": null,
            "Quizz : Activité": null,
            "pet-name": null,
            "Quizz : Date": null
          };
    
          _learnq.push(['identify', unset_values]);
    
        }, 6000);
    
        setTimeout(() => {
          // Klaviyo
          let klaviyo_data = {};
          klaviyo_data['$email'] = quizResultsJSON.email;
          if (quizResultsJSON.accept_marketing) {
            klaviyo_data['Accepts Marketing'] = true;
            let data_make = {
              'email': quizResultsJSON.email
            };
            
            fetch("https://hook.eu1.make.com/j6ejcc23r46o1m3mkiu8ukceup5gpyq7", {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data_make)
            })
            .then(response => {
    
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }
          for (let index = 0; index < quizResultsJSON.klaviyo_answer.length; index++) {
            klaviyo_data[quizResultsJSON.klaviyo_answer[index].klaviyo_answer_title] = quizResultsJSON.klaviyo_answer[index].klaviyo_answer_data;
          }
    
          console.log("klaviyo_data");
          console.log(klaviyo_data);
    
          _learnq.push(['identify', klaviyo_data]);
    
          let pushEmail = _learnq.push(['track', 'quiz_resultat', {
            'quiz_url': share_url
          }]);
    
          console.log('Push tracking', pushEmail);
    
        }, 7000);
      }
    }

    async getProductTemplate(handle) {
      let self = this;
      await fetch('/products/' + handle + '?section_id=quiz-product-atc')
        .then(response => response.text())
        .then(data => {
          self.resultContainer.insertAdjacentHTML('beforeend', data);			
        });

        let settings = {
          selectorData : 'data-only-mobile-f'
        };
        
        let isMobile = false;
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
            isMobile = true;
        }
        if (isMobile) {
          let carousel = self.resultContainer.querySelector('.carousel');
          let carouselData = carousel.getAttribute(settings.selectorData);
          let flkty = Flickity.data( carousel );
          if (flkty) {
            flkty.destroy();
            let flkty2 = new Flickity( carousel, carouselData);
          } else {
            let flkty2 = new Flickity( carousel, carouselData);
          }
        }

        // Initialize subscription functionality for this product
        this.initializeQuizProductSubscription(handle);
    }

    initializeQuizProductSubscription(handle) {
      const productContainer = this.resultContainer.querySelector(`[data-quiz-product-handle="${handle}"]`);
      if (!productContainer) return;

      const productId = productContainer.getAttribute('data-product-id');
      
      // Get elements
      const variantInputs = productContainer.querySelectorAll('.bundle__product-variants__container input[type="radio"]');
      const quantityInput = productContainer.querySelector('.quantity-input');
      const incrementBtn = productContainer.querySelector('.increment');
      const decrementBtn = productContainer.querySelector('.decrement');
      const oneTimePriceEl = productContainer.querySelector('.quiz-onetime-price');
      const subscriptionPriceEl = productContainer.querySelector('.quiz-subscription-price');
      const purchaseTypeRadios = productContainer.querySelectorAll(`input[name="quiz-purchaseType-${productId}"]`);
      const frequencySelector = productContainer.querySelector(`#quiz-frequencySelector-${productId}`);
      const frequencySelect = productContainer.querySelector(`#quiz-frequencySelect-${productId}`);
      const addToCartBtn = productContainer.querySelector('.bundle__product-cta');

      // Function to update prices
      const updatePrices = () => {
        const selectedVariant = productContainer.querySelector('.bundle__product-variants__container input[type="radio"]:checked');
        if (!selectedVariant) return;

        const variantPrice = parseFloat(selectedVariant.getAttribute('data-variant-price').replace(',', '.'));
        const quantity = parseInt(quantityInput.value) || 1;
        const oneTimeTotal = variantPrice * quantity;
        const subscriptionTotal = (variantPrice * 0.8) * quantity; // 20% off

        if (oneTimePriceEl) oneTimePriceEl.textContent = `${oneTimeTotal.toFixed(2)}€`;
        if (subscriptionPriceEl) subscriptionPriceEl.textContent = `${subscriptionTotal.toFixed(2)}€`;
      };

      // Initial price update
      updatePrices();

      // Listen to variant changes
      variantInputs.forEach(input => {
        input.addEventListener('change', updatePrices);
      });

      // Listen to quantity changes
      if (incrementBtn) {
        incrementBtn.addEventListener('click', () => {
          setTimeout(updatePrices, 10);
        });
      }
      if (decrementBtn) {
        decrementBtn.addEventListener('click', () => {
          setTimeout(updatePrices, 10);
        });
      }
      if (quantityInput) {
        quantityInput.addEventListener('change', updatePrices);
      }

      // Listen to purchase type changes
      if (purchaseTypeRadios.length > 0) {
        purchaseTypeRadios.forEach(radio => {
          radio.addEventListener('change', (e) => {
            if (e.target.value === 'subscription') {
              if (frequencySelector) frequencySelector.style.display = 'block';
              if (addToCartBtn) addToCartBtn.disabled = true;
            } else {
              if (frequencySelector) frequencySelector.style.display = 'none';
              if (addToCartBtn) addToCartBtn.disabled = false;
            }
          });
        });
      }

      // Listen to frequency selection
      if (frequencySelect) {
        frequencySelect.addEventListener('change', (e) => {
          const subscriptionRadio = productContainer.querySelector(`#quiz-subscription-${productId}`);
          if (subscriptionRadio && subscriptionRadio.checked && addToCartBtn) {
            addToCartBtn.disabled = !e.target.value;
          }
        });
      }

      // Handle add to cart
      if (addToCartBtn && !addToCartBtn.hasAttribute('data-quiz-subscription-handler')) {
        addToCartBtn.setAttribute('data-quiz-subscription-handler', 'true');
        
        addToCartBtn.addEventListener('click', async (e) => {
          e.stopImmediatePropagation(); // Prevent theme.js handler from executing
          
          const selectedVariant = productContainer.querySelector('.bundle__product-variants__container input[type="radio"]:checked');
          if (!selectedVariant) {
            alert('Please select a variant');
            return;
          }

          const variantId = selectedVariant.value;
          const quantity = parseInt(quantityInput.value) || 1;
          const subscriptionRadio = productContainer.querySelector(`#quiz-subscription-${productId}`);
          const isSubscription = subscriptionRadio && subscriptionRadio.checked;
          const selectedFrequency = frequencySelect ? frequencySelect.value : '';

          if (isSubscription && !selectedFrequency) {
            alert('Please select a subscription frequency');
            return;
          }

          try {
            if (isSubscription) {
              // Get product data to find selling plan
              const productHandle = productContainer.getAttribute('data-quiz-product-handle');
              const response = await fetch(`/products/${productHandle}.js`);
              const productData = await response.json();
              
              const selectedVariantData = productData.variants.find(v => v.id == variantId);
              
              const cartProperties = {
                "_shipping_interval_frequency": selectedFrequency,
                "_shipping_interval_unit_type": "Days"
              };

              if (selectedVariantData && selectedVariantData.selling_plan_allocations && selectedVariantData.selling_plan_allocations.length > 0) {
                const sellingPlan = selectedVariantData.selling_plan_allocations[0];
                
                const items = [{
                  id: variantId,
                  quantity: quantity,
                  selling_plan: sellingPlan.selling_plan_id,
                  properties: cartProperties
                }];
                
                CartJS.addItems(items);
              } else {
                CartJS.addItem(variantId, quantity, cartProperties);
              }
            } else {
              // One-time purchase
              CartJS.addItem(variantId, quantity, {});
            }
          } catch (error) {
            console.error('Error adding to cart:', error);
            alert('Error adding product to cart. Please try again.');
          }
        }, true); // Use capture phase to run before theme.js handler
      }
    }

    async getArticleTemplate(handle) {
      let self = this;
      await fetch('/blogs/news/' + handle + '?section_id=quiz-article-card')
        .then(response => response.text())
        .then(data => {
          let parser = new DOMParser();
          let doc = parser.parseFromString(data, 'text/html');
          let article = doc.querySelector('[data-quiz-article]');
          if (article == null) {
            return;
          }
          self.articlesContainer.insertAdjacentHTML('beforeend', article.outerHTML);
        });
    }

    async getReviewsTemplate(handle) {
      let self = this;
      await fetch('/products/' + handle + '?section_id=quiz-reviews')
        .then(response => response.text())
        .then(data => {
          self.reviewsContainer.insertAdjacentHTML('beforeend', data);
        });

        self.reviewsContainer.classList.remove('hide');   
    }

    showReviews() {
      let settings = {
        selectorData : 'data-only-mobile-f'
      };
      
      let isMobile = false;
      // device detection
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
          || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
          isMobile = true;
      }
      if (isMobile) {
        let carousel = this.reviewsContainer.querySelector('.quiz-reviews__container');
        let carouselData = carousel.getAttribute(settings.selectorData);
        let flkty = Flickity.data( carousel );
        if (flkty) {
          flkty.destroy();
          let flkty2 = new Flickity( carousel, carouselData);
        } else {
          let flkty2 = new Flickity( carousel, carouselData);
        }
      }
    }

    showResults() {
      if (document.querySelector('.questionnaire-banner-load') != null) {
        document.querySelector('.questionnaire-banner-load').classList.add('hide');
      }
      if (document.querySelector('.quiz-banner') != null) {
        document.querySelector('.quiz-banner').classList.remove('hide');
      }
      if (document.querySelector('.quiz-reviews') != null) {
        document.querySelector('.quiz-reviews').classList.remove('hide');
      }
      if (document.querySelector('.quiz-blog') != null) {
        document.querySelector('.quiz-blog').classList.remove('hide');
      }
      window.dispatchEvent(new Event('resize'));
      // Event impression
      if (this.querySelectorAll('section-bundle [data-product-card]').length > 0) {
        var products = [];

        this.querySelectorAll('section-bundle [data-product-card]').forEach(function (element, index) {
          products.push({
            id: element.getAttribute('data-product-id'),
            name: element.getAttribute('data-product-name'),
            price: parseFloat(element.getAttribute('data-product-price')) || 0,
            type: element.getAttribute('data-product-type'),
            list: (window.location.href.split('?')[0].split('/').filter(part => part).pop()).replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()),
            espece: element.getAttribute('data-product-espece'),
            stock: element.getAttribute('data-product-stock'),
            discount: parseFloat(element.getAttribute('data-product-discount')) || 0,
            position: index + 1
          });
        });

        gtmImpression({ products: products });
      }

      // Event click product
      this.querySelectorAll('section-bundle [data-product-card-click]').forEach(function (element) {
        element.addEventListener('click', function (event) {
          if (!event.target.closest('.bundle__product-cta, .product-card__cta')) {
            var product = {
                id: element.getAttribute('data-product-id'),
                name: element.getAttribute('data-product-name'),
                price: parseFloat(element.getAttribute('data-product-price')),
                type: element.getAttribute('data-product-type'),
                list: (window.location.href.split('?')[0].split('/').filter(part => part).pop()).replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()),
                espece: element.getAttribute('data-product-espece'),
                stock: element.getAttribute('data-product-stock'),
                discount: parseFloat(element.getAttribute('data-product-discount') || '0'),
                position: parseInt(element.getAttribute('data-product-position') || '1'),
                quantity: 1  // Adding quantity field
            };
            gtmClickProduct(product);
            gtmProductDetail(product);
          }
        });
      });
    }

    replaceAllNames(node, name) {
      node.childNodes.forEach(child => {
        if (child.nodeType === Node.TEXT_NODE) {
          // Remplace dans les textes
          child.textContent = child.textContent.replace(/#NAME#/g, name);
        } else {
          // Si ce n'est pas du texte, on continue de descendre dans l'arbre DOM
          this.replaceAllNames(child, name);
        }
      });
    }

    setUpsell(type_animal) {
      let settings = {
        selector: '[data-only-mobile-f]',
        selectorData : 'data-only-mobile-f'
      };

      this.upsellElements.forEach(upsell => {
        const upsellType = upsell.getAttribute('data-quiz-upsell').toLowerCase();
        if (upsellType === type_animal.toLowerCase()) {
          upsell.classList.remove('hide');

          var carousel = upsell.querySelector('.collection-slider__carousel, [data-flickity], [data-only-mobile-f]');
          if (carousel && window.Flickity) {
            var flkty = Flickity.data(carousel);
            if (flkty) {
              flkty.resize();
            }
          }

          let isMobile = false;
          // device detection
          if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
              || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
              isMobile = true;
          }
          if (isMobile) {
            let carousel = upsell.querySelector(settings.selector);
            if (carousel) {
              let carouselData = carousel.getAttribute(settings.selectorData);
              let flkty = Flickity.data( carousel );
              if (flkty) {
                flkty.destroy();
                let flkty2 = new Flickity( carousel, carouselData);
              } 
            }
          }
        }
      });
    }

    setProblematiques(problematiques, type_animal) {
      const problematiqueMap = {
        "Q7A1": "Allergique",
        "Q7A2": "Souffre de problèmes de peau",
        "Q7A3": "Stérilisé",
        "Q7A4": "En surpoids",
        "Q7A5": "Boude sa gamelle",
        "Q7A6": "A une digestion sensible",
        "Q7A7": "Arthrose",
        "Q7A8": "Anxiété",
        "Q7A9": "Problème urinaire",
        "Q7A10": "Tout va bien"
      };
    
      const filteredProblematiques = problematiques.map(code => problematiqueMap[code]);
      
      let visibleIndex = 1; // Compteur pour les encarts visibles
    
      this.encarts.forEach(encart => {
        const encartType = encart.getAttribute('data-quiz-encart-type').toLowerCase();
        const encartProblematique = encart.getAttribute('data-quiz-encart-problematique');
    
        if (encartType !== type_animal.toLowerCase() || !filteredProblematiques.includes(encartProblematique)) {
          encart.style.display = 'none';
        } else {
          const numberElement = encart.querySelector('[data-quiz-encart-number]');
          if (numberElement) {
            numberElement.textContent = visibleIndex;
          }
          visibleIndex++; // Incrémenter le compteur pour les éléments visibles
          encart.style.display = ''; // S'assurer que l'encart est visible (au cas où il était masqué avant)
          if (visibleIndex == 2) {
            encart.querySelector('h2.quiz-banner__encart-text--accordion-title.only-mobile').classList.add('active');
          }
        }
      });
    }
  }
)
